import { TFunction } from '@lyearn/i18n';
import routes from '@/pages/corporate/routes';

interface GetBreadcrumbsParams {
  t: TFunction;
  title: string;
}

export const getBreadcrumbs = ({ t, title }: GetBreadcrumbsParams) => [
  {
    label: t('Admin:AllContent'),
    to: routes.LearningContent(),
  },
  {
    label: title,
  },
];

export const getEmbeddedBreadcrumbs = ({ title }: { title: string }) => [
  {
    label: title,
  },
];
